import React from 'react';
import { translations } from '../../translations';
import './Intro.css';

const Intro = ({ language = 'en' }) => {
  const t = translations[language]?.intro || translations.en.intro;

  return (
    <section className="intro">
      <div className="intro__container">
        <h2 className="intro__title">{t.title}</h2>
        <p className="intro__subtitle">{t.text1}</p>
        <p className="intro__subtitle intro__subtitle--prompt">{t.text2}</p>
        {t.checks && (
          <ul className="intro__checks">
            {t.checks.map((item, index) => (
              <li key={index} className="intro__check-item">
                <svg className="intro__check-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/>
                </svg>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        )}
        <p className="intro__closing">{t.text3}</p>
        <a href="https://instacarspa.simplybook.me/v2/" target="_blank" rel="noopener noreferrer" className="intro__button">{t.button}</a>
      </div>
    </section>
  );
};

export default Intro;
